import { Component, OnInit } from '@angular/core';
import { TableColumn } from '../../../dto/util/table-column';
import { FiltroAdminDTO } from '../models/filtroAdminDTO';
import { AdministracionUsuariosService } from '../services/administracion-usuarios.service';
import { RespuestaDTO } from '../models/respuestaDTO';
import { AdminTableDTO } from '../models/adminDTO';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { Constants } from '../../../constants/constants';
import { Router } from '@angular/router';
import { FormFieldOption } from '../../../dto/util/form-field';
import { ListasService } from '../../../services/listas.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lista-administradores',
  templateUrl: './lista-administradores.component.html',
  styleUrl: './lista-administradores.component.scss',
})
export class ListaAdministradoresComponent implements OnInit {
  // Boolean
  esAdminLider = false;
  esAdminLiderMjd = false;
  esSuperAdmin = false;
  usuarioSeleccionado = false;

  // Listas
  administradoresLideres: AdminTableDTO[] = [];
  administradoresFuncionales: AdminTableDTO[] = [];
  columnasAdminLider: TableColumn[] = [];
  columnasAdminFuncional: TableColumn[] = [];
  entidades: FormFieldOption[] = [];
  tiposDocumento: FormFieldOption[] = [];

  // Tables
  tamanoPaginaLider = 10;
  totalPaginasLider = 0;
  paginaActualLider = 1;

  tamanoPaginaFuncional = 10;
  totalPaginasFuncional = 0;
  paginaActualFuncional = 1;

  // Number
  idUsuario!: number;
  idEntidad!: number;
  dataAdmin!: AdminTableDTO;

  filtroAdminLider: FiltroAdminDTO = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: true,
    ordenarPor: 'nombres',
    filtros: {
      nombres: '',
      apellidos: '',
      idTipoIdentificacion: '',
      identificacion: '',
      correoElectronico: '',
      entidad: '',
      estado: null,
      fechaActivacion: '',
    },
  };

  filtroAdminFuncional: FiltroAdminDTO = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: true,
    ordenarPor: 'nombres',
    filtros: {
      nombres: '',
      apellidos: '',
      idTipoIdentificacion: '',
      identificacion: '',
      correoElectronico: '',
      entidad: '',
      estado: null,
      fechaActivacion: '',
    },
  };
  filtroAdminFuncionalMjd: FiltroAdminDTO = {
      pagina: 1,
      tamanoPagina: 10,
      ordenarAsc: true,
      ordenarPor: 'nombres',
      filtros: {
        nombres: '',
        apellidos: '',
        idTipoIdentificacion: '',
        identificacion: '',
        correoElectronico: '',
        entidad: null,
        estado: null,
        fechaActivacion: '',
      },
    };
  // Multilenguaje
  tableText: any = {};
  constructor(
    private adminUsuariosService: AdministracionUsuariosService,
    private alertService: AlertaModalService,
    private route: Router,
    private listaService: ListasService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    infoInicioSesion.Id_Entidad =infoInicioSesion.Id_Entidad ?? null;
    if (infoInicioSesion.Nombre === 'Superadministrador') {
      this.esSuperAdmin = true;
      this.esAdminLider = false;
    } else if (infoInicioSesion.Nombre === 'Administrador Lider' && infoInicioSesion.Id_Entidad !== null) {
      this.esAdminLider = true;
      this.esSuperAdmin = false;
      this.idEntidad = infoInicioSesion.Id_Entidad;
    } else if  (infoInicioSesion.Nombre === 'Administrador Lider' && infoInicioSesion.Id_Entidad === null) {
    this.esAdminLiderMjd = true ;
      this.esAdminLider = false;
      this.esSuperAdmin = false;
    } else {
      this.route.navigateByUrl('/');
    }
    // Multilenguaje
    this.translate.stream('gestion-usuarios').forEach(text => {
      for (const key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      if (this.esSuperAdmin) {
        this.initColumnsLider();
      }
      if (this.esAdminLider) {
        this.initColumnsFuncional();
      }

    });
    // Se valida si es administrador líder
    if (this.esSuperAdmin) {
      // Lista de entidades
      this.listaService.getEntidades().subscribe(entidades => {
        this.entidades = entidades.map(entidad => ({
          Id: entidad.Id ?? '',
          Nombre: entidad.Entidad || '',
        }));
        this.initColumnsLider();
      });
      // Lista de tipos de documento
      this.listaService.getDocumentTypeList().subscribe(entidades => {
        this.tiposDocumento = entidades.map(tipo => ({
          Id: tipo.Id ?? '',
          Nombre: tipo.Descripcion || '',
        }));
        this.initColumnsLider();
      });
      this.initColumnsLider();
      // Consumo de servicio de listar
      this.listarAdminLideres();
    }

    // Se valida si es administrador funcional
    if (this.esAdminLider) {
      this.filtroAdminFuncional.filtros = {
        entidad: infoInicioSesion.Id_Entidad,
      };
      // Lista de tipos de documento
      this.listaService.getDocumentTypeList().subscribe(entidades => {
        this.tiposDocumento = entidades.map(tipo => ({
          Id: tipo.Id ?? '',
          Nombre: tipo.Descripcion || '',
        }));
        this.initColumnsFuncional();
      });
      this.initColumnsFuncional();
      // Consumo de servicio de listar
      this.listarAdminFuncionales();


    }
    if (this.esAdminLiderMjd) {
       this.filtroAdminFuncionalMjd.filtros = {
        entidad: infoInicioSesion.Id_Entidad && Object.keys(infoInicioSesion.Id_Entidad).length !== 0
          ? null
          : infoInicioSesion.Id_Entidad
        };

          // Lista de tipos de documento
          this.listaService.getDocumentTypeList().subscribe(entidades => {
            this.tiposDocumento = entidades.map(tipo => ({
              Id: tipo.Id ?? '',
              Nombre: tipo.Tipo_Documento || '',
            }));
            this.initColumnsFuncional();
          });
          this.initColumnsFuncional();
          // Consumo de servicio de listar
          this.listarAdminFuncionalesMjd();
        }

  }


  // Se iniciaizan columnas de la tabla de administradores líderes
  initColumnsLider() {
    this.columnasAdminLider = [
    {
      id: 'username',
      field: 'username',
      title: this.tableText['username'],
      type: 'text',
      filterable: true,
      sortable: true,
      width: '10rem',
          },
      {
        id: 'nombres',
        field: 'nombres',
        title: this.tableText['nombres'],
        type: 'text',
        filterable: true,
        sortable: true,
        width: '10rem',
      },

      {
        id: 'tipoIdentificacion',
        field: 'tipoIdentificacion',
        title: this.tableText['tipo-identificacion'],
        type: 'select',
        elements: this.tiposDocumento,
        option: 'Nombre',
        value: 'Id',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
      {
        id: 'identificacion',
        field: 'identificacion',
        title: this.tableText['numero-identificacion'],
        type: 'number',
        filterable: true,
        sortable: true,
      },
      {
        id: 'correoElectronico',
        field: 'correoElectronico',
        title: this.tableText['correo'],
        type: 'text',
        filterable: true,
        sortable: true,
      },
      {
        id: 'entidad',
        field: 'entidad',
        title: this.tableText['entidad'],
        type: 'select',
        elements: this.entidades,
        value: 'Id',
        option: 'Nombre',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
      {
        id: 'fechaActivacion',
        field: 'fechaActivacion',
        title: this.tableText['fecha-activacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
      {
        id: 'estado',
        field: 'estado',
        title: this.tableText['estado'],
        type: 'select',
        elements: [
          { Id: true, Nombre: 'Habilitado' },
          { Id: false, Nombre: 'Inhabilitado' },
        ],
        value: 'Id',
        option: 'Nombre',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
    ];
  }

  // Se iniciaizan columnas de la tabla de administradores funcionales
  initColumnsFuncional() {
    this.columnasAdminFuncional = [
      {
        id: 'username',
        field: 'username',
        title: this.tableText['username'],
        type: 'text',
        filterable: true,
        sortable: true,
        width: '10rem',
      },
      {
        id: 'nombres',
        field: 'nombres',
        title: this.tableText['nombres'],
        type: 'text',
        filterable: true,
        sortable: true,
        width: '10rem',
      },
      {
        id: 'tipoIdentificacion',
        field: 'tipoIdentificacion',
        title: this.tableText['tipo-identificacion'],
        type: 'select',
        elements: this.tiposDocumento,
        option: 'Nombre',
        value: 'Id',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
      {
        id: 'identificacion',
        field: 'identificacion',
        title: this.tableText['numero-identificacion'],
        type: 'text',
        filterable: true,
        sortable: true,
      },
      {
        id: 'correoElectronico',
        field: 'correoElectronico',
        title: this.tableText['correo'],
        type: 'text',
        filterable: true,
        sortable: true,
      },
      {
        id: 'fechaActivacion',
        field: 'fechaActivacion',
        title: this.tableText['fecha-activacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
      {
        id: 'estado',
        field: 'estado',
        title: this.tableText['estado'],
        type: 'select',
        elements: [
          { Id: true, Nombre: 'Habilitado' },
          { Id: false, Nombre: 'Inhabilitado' },
        ],
        value: 'Id',
        option: 'Nombre',
        filterable: true,
        sortable: true,
        width: '12rem',
      },
    ];
  }
  // Función que consume el servicio de listar administradores líderes
  listarAdminLideres() {
    this.adminUsuariosService
      .listarAdminLideres(this.filtroAdminLider)
      .subscribe((resp: RespuestaDTO) => {
        if (resp.status === 200) {
          this.totalPaginasLider = resp.data.totalPaginas;
          this.paginaActualLider = resp.data.numeroPagina;
          this.tamanoPaginaLider = resp.data.cantidadRegistros;
          resp.data.registros.forEach(admin => {
            this.administradoresLideres.push({
              id: admin.Persona.Usuario.Id,
              username:
              admin.Persona.Usuario.Username,
              nombres:
                admin.Primer_nombre +
                (admin.Segundo_nombre ? ' ' + admin.Segundo_nombre : '')+ " "+
                admin.Primer_apellido +
                (admin.Segundo_apellido ? ' ' + admin.Segundo_apellido : ''),

              tipoIdentificacion: admin.Persona.Tipo_Documento.Descripcion,
              descTipoIdentificacion: admin.Persona.Tipo_Documento.Descripcion,
              identificacion: admin.Persona.Identificacion,
              correoElectronico: admin.Persona.Correo_electronico,
              entidad:
                admin.Persona.Usuario.Tipos_Usuario[0].Tipo_Usuario.Entidad
                  ?.Entidad,
              estado: admin.Persona.Usuario.Estado
                ? 'Habilitado'
                : 'Inhabilitado',
              fechaActivacion: admin.fechaActivacion ? new Date(admin.fechaActivacion).toLocaleDateString('es-CO', {
                timeZone: 'UTC'}) : null
            });
          });
        } else {
          this.alertService.error(resp.message);
        }
      });
  }

  // Función que consume el servicio de listar administradores funcionales
  listarAdminFuncionales() {
    this.adminUsuariosService
      .listarAdminFuncionales(this.filtroAdminFuncional)
      .subscribe((resp: RespuestaDTO) => {
        if (resp.status === 200) {
          this.totalPaginasFuncional = resp.data.totalPaginas;
          this.paginaActualFuncional = resp.data.numeroPagina;
          this.tamanoPaginaFuncional = resp.data.cantidadRegistros;
          resp.data.registros.forEach(admin => {
            this.administradoresFuncionales.push({
              id: admin.Persona.Usuario.Id,
              username:
              admin.Persona.Usuario.Username,
              nombres:
              admin.Primer_nombre +
              (admin.Segundo_nombre ? ' ' + admin.Segundo_nombre : '')+ " "+
              admin.Primer_apellido +
              (admin.Segundo_apellido ? ' ' + admin.Segundo_apellido : ''),
              tipoIdentificacion: admin.Persona.Tipo_Documento.Descripcion,
              descTipoIdentificacion: admin.Persona.Tipo_Documento.Descripcion,
              identificacion: admin.Persona.Identificacion,
              correoElectronico: admin.Persona.Correo_electronico,
              entidad:
                admin.Persona.Usuario.Tipos_Usuario[0].Tipo_Usuario.Entidad
                  ?.Entidad,
              estado: admin.Persona.Usuario.Estado
                ? 'Habilitado'
                : 'Inhabilitado',
              fechaActivacion: admin.fechaActivacion ? new Date(admin.fechaActivacion).toLocaleDateString('es-CO', {
                timeZone: 'UTC'}): null
            });
          });
        } else {
          this.alertService.error(resp.message);
        }
      });
  }
    listarAdminFuncionalesMjd() {
    this.adminUsuariosService
      .listarAdminFuncionalesMjd(this.filtroAdminFuncionalMjd)
      .subscribe((resp: RespuestaDTO) => {
        if (resp.status === 200) {
          this.totalPaginasFuncional = resp.data.totalPaginas;
          this.paginaActualFuncional = resp.data.numeroPagina;
          this.tamanoPaginaFuncional = resp.data.cantidadRegistros;
          resp.data.registros.forEach(admin => {
            this.administradoresFuncionales.push({
              id: admin.Persona.Usuario.Id,
              username:
              admin.Persona.Usuario.Username,
              nombres:
              admin.Primer_nombre +
              (admin.Segundo_nombre ? ' ' + admin.Segundo_nombre : '')+ " "+
              admin.Primer_apellido +
              (admin.Segundo_apellido ? ' ' + admin.Segundo_apellido : ''),
              tipoIdentificacion: admin.Persona.Tipo_Documento.Descripcion,
              descTipoIdentificacion: admin.Persona.Tipo_Documento.Descripcion,
              identificacion: admin.Persona.Identificacion,
              correoElectronico: admin.Persona.Correo_electronico,
              entidad:null,
              estado: admin.Persona.Usuario.Estado
                ? 'Habilitado'
                : 'Inhabilitado',
              fechaActivacion: admin.fechaActivacion ? new Date(admin.fechaActivacion).toLocaleDateString('es-CO', {
                timeZone: 'UTC'}): null
            });
          });
        } else {
          this.alertService.error(resp.message);
        }
      });
  }


  // Evento buscar de la tabla de administradores líderes
  buscarLideres(event: FiltroDto<object>) {
    this.filtroAdminLider.ordenarPor =
      event.ordenarPor == '' ? 'nombres' : event.ordenarPor;
    this.filtroAdminLider.filtros = event.filtros;
    this.filtroAdminLider.ordenarAsc = event.ordenarAsc;
    this.filtroAdminLider.pagina = +(event.selectedPage ?? 1);
    this.filtroAdminLider.tamanoPagina = +event.tamanoPagina;
    this.administradoresLideres = [];
    this.listarAdminLideres();
  }

  // Evento buscar de la tabla de administradores funcionales
  buscarFuncionales(event: FiltroDto<object>) {
    this.filtroAdminFuncional.ordenarPor =
      event.ordenarPor == '' ? 'nombres' : event.ordenarPor;
    this.filtroAdminFuncional.filtros = {
      ...event.filtros,
      entidad: this.idEntidad,
    };
    this.filtroAdminFuncional.ordenarAsc = event.ordenarAsc;
    this.filtroAdminFuncional.pagina = +(event.selectedPage ?? 1);
    this.filtroAdminFuncional.tamanoPagina = +event.tamanoPagina;
    this.administradoresFuncionales = [];
    this.listarAdminFuncionales();
  }
  buscarFuncionalesMjd(event: FiltroDto<object>) {
      this.filtroAdminFuncionalMjd.ordenarPor =
        event.ordenarPor == '' ? 'nombres' : event.ordenarPor;
      this.filtroAdminFuncionalMjd.filtros = {
        ...event.filtros,
        entidad: this.idEntidad,
      };
      this.filtroAdminFuncionalMjd.ordenarAsc = event.ordenarAsc;
      this.filtroAdminFuncionalMjd.pagina = +(event.selectedPage ?? 1);
      this.filtroAdminFuncionalMjd.tamanoPagina = +event.tamanoPagina;
      this.administradoresFuncionales = [];
      this.listarAdminFuncionalesMjd();
    }

  verificarSeleccion(event: AdminTableDTO[]) {
    event.forEach(admin => {
      this.idUsuario = admin.id;
      this.dataAdmin = admin;
    });
    if (event.length === 1) {
      this.usuarioSeleccionado = true;
    } else {
      this.usuarioSeleccionado = false;
    }
  }

  // Redirección al componente de creación de administrador
  crearAdministrador() {
    if (this.esSuperAdmin) {
      this.route.navigateByUrl('administracion-usuarios/crear-admin-lider');
    } else if (this.esAdminLider) {
       this.route.navigateByUrl(
       `administracion-usuarios/crear-admin-funcional/${this.idEntidad}`
         );
     }else if(this.esAdminLiderMjd){
       this.route.navigateByUrl(
        `administracion-usuarios/crear-admin-funcional/mdj`
                );
       }

    }


  // Redirección al componente de modificación de administrador
  modificarAdministrador() {
    if (this.esSuperAdmin) {
      this.route.navigateByUrl(
        `administracion-usuarios/modificar-admin-lider/${this.idUsuario}`
      );
    } else if (this.esAdminLider) {
      this.route.navigateByUrl(
        `administracion-usuarios/modificar-admin-funcional/${this.idUsuario}`
      );
    }
    else if (this.esAdminLiderMjd) {
          this.route.navigateByUrl(
            `administracion-usuarios/modificar-admin-funcional/${this.idUsuario}`
          );
        }
  }

  // Eliminar usuario
  eliminarUsuario() {
    this.alertService.confirmacion(
      this.tableText['username'] +
        ': ' +
        this.dataAdmin.username +
        ' ' +
        this.tableText['nombres'] +
        ': ' +
        this.dataAdmin.nombres +
        ' ' +
        this.tableText['tipo-identificacion'] +
        ': ' +
        this.dataAdmin.tipoIdentificacion +
        ' ' +
        this.tableText['numero-identificacion'] +
        ': ' +
        this.dataAdmin.identificacion +
        ' ' +
        this.tableText['correo'] +
        ': ' +
        this.dataAdmin.correoElectronico,
      // Se muestran los datos del usuario
      this.tableText['confirmar_eliminar'],
      () => {
        // Se consume el servicio de eliminar
        this.adminUsuariosService
          .eliminarUsuario(this.idUsuario)
          .subscribe(resp => {
            if (resp.status === 200) {
              this.alertService.exito(this.tableText['eliminado_exitoso']);
              if (this.esAdminLider) {
                this.administradoresFuncionales = [];
                this.listarAdminFuncionales();
              } else if (this.esSuperAdmin) {
                this.administradoresLideres = [];
                this.listarAdminLideres();
              }
            }
          });
      },
      () => {

      }
    );
  }
}
